import { render, staticRenderFns } from "./DtCountdown.vue?vue&type=template&id=a5fcb9f0&"
import script from "./DtCountdown.vue?vue&type=script&lang=js&"
export * from "./DtCountdown.vue?vue&type=script&lang=js&"
import style0 from "./DtCountdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports